import { BrandKit } from "@redotech/redo-content-builder-common/brand-kit";
import { createPendingTextToSubscribeRecordSchema } from "@redotech/redo-marketing-common/schemas/create-pending-text-to-subscribe-record-schema";
import { getSignupFormSchema } from "@redotech/redo-marketing-common/schemas/get-signup-form-schema";
import {
  SignupFormLocation,
  submitSignupFormStepSchema as submitSignupFormStep,
} from "@redotech/redo-marketing-common/schemas/submit-signup-form-step-schema";
import { logSignupFormAnalyticsSchema as logSignupFormAnalytics } from "@redotech/redo-marketing-common/schemas/view-signup-form-schema";
import { SignupForm } from "@redotech/redo-marketing-common/signup-form/signup-form-schema";
import { MarketingEntryPoint } from "@redotech/redo-marketing-entry-point-common/marketing-entry-point";
import { RedoMarketingPopupFormInstance } from "@redotech/redo-web-marketing/marketing/signup-form/popup-form-instance";
import { SignupFormClient } from "@redotech/redo-web-marketing/marketing/signup-form/types";
import { getCustomFieldOptions } from "@redotech/shopify-sdk/rpc/schema/marketing-embedded-form/get-custom-field-options";
import { memo, useContext, useMemo } from "react";
import { RedoShopifyRpcClientContext } from "../client/redo-shopify-rpc-client";

export const SignupFormInstanceWrapper = memo(
  function SignupFormInstanceWrapper({
    brandKit,
    utmParams,
    forceId,
    forceForm,
  }: {
    brandKit: BrandKit;
    utmParams: string;
    forceId?: string;
    forceForm?: SignupForm;
  }) {
    const rpcClient = useContext(RedoShopifyRpcClientContext);
    const shopifyCustomerId = useMemo(
      () =>
        (
          globalThis as any
        ).ShopifyAnalytics?.meta?.page?.customerId?.toString() ?? null,
      [],
    );

    const client: SignupFormClient | undefined = useMemo(() => {
      if (!rpcClient) {
        return;
      }
      return {
        getSignupForm: async (params, options) =>
          rpcClient(getSignupFormSchema, params, options),
        getCustomFieldOptions: async (params) =>
          rpcClient(getCustomFieldOptions, params),
        logSignupFormAnalytics: async (params) =>
          rpcClient(logSignupFormAnalytics, params),
        submitSignupFormStep: async (params) =>
          rpcClient(submitSignupFormStep, params),
        createPendingTextToSubscribeRecord: async (params) =>
          rpcClient(createPendingTextToSubscribeRecordSchema, params),
      } satisfies SignupFormClient;
    }, [rpcClient]);

    const location =
      globalThis.redoStorefront?.type === "commentsold"
        ? SignupFormLocation.COMMENTSOLD_STOREFRONT
        : SignupFormLocation.SHOPIFY_STOREFRONT;
    return (
      <>
        <RedoMarketingPopupFormInstance
          brandKit={brandKit}
          entryPoint={MarketingEntryPoint.SIGNUP_FORM}
          forceForm={forceForm}
          forceId={forceId}
          location={location}
          mode="normal"
          rpcClient={client}
          shopifyCustomerId={shopifyCustomerId}
          site="marketing"
          utmParams={utmParams}
        />
        <RedoMarketingPopupFormInstance
          brandKit={brandKit}
          entryPoint={MarketingEntryPoint.SIGNUP_FORM}
          location={location}
          mode="exit-intent"
          rpcClient={client}
          shopifyCustomerId={shopifyCustomerId}
          site="marketing"
          utmParams={utmParams}
        />
      </>
    );
  },
);
